const errorMessageHelper = (value) => {
    if ( typeof value === "object") {
        if (value.errors) {
            const errors = value.errors;
            const errorMessages = [];

            for (const key in errors) {
                if (errors.hasOwnProperty(key)) {
                    errorMessages.push(errors[key].join('; '));
                }
            }
            console.log("to tentando");
         console.log( errorMessages.join(' | '));
            return errorMessages.join(' | ');
        } else if (value.msg) {
            return value.msg ?? value.message 
        }
    }
    return "Ocorreu um erro desconhecido."; // Mensagem padrão se a estrutura não for conforme esperado
};

export default errorMessageHelper;
